<template>
  <div>
    <div class="mt-16">
      <div class="echarts">
        <div id="size" style="width: 460px; margin: 0 auto; height: 290px"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['activityScale'],
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      bottomOption: {},
      currData: [
        { value: 1048, name: '小型活动' },
        { value: 735, name: '中性活动' },
        { value: 580, name: '大型活动' },
      ],
    }
  },
  watch: {
    activityScale: {
      handler: function () {
        this.currData[0].value = this.activityScale.smallNum
        this.currData[1].value = this.activityScale.middleNum
        this.currData[2].value = this.activityScale.bigNum
        this.initBarChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.currData[0].value = this.activityScale.smallNum
    this.currData[1].value = this.activityScale.middleNum
    this.currData[2].value = this.activityScale.bigNum
    this.initBarChart()
  },
  methods: {
    initBarChart() {
      var myChart = this.$echarts.init(document.getElementById('size'))
      this.bottomOption = {
        title: {
          //   text: 'Referer of a Website',
          //   subtext: 'Fake Data',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          top: '16px',
          textStyle: {
            color: '#fff',
          },
        },
        series: [
          {
            name: '活动规模',
            type: 'pie',
            radius: '70%',
            data: this.currData,
            avoidLabelOverlap: false,
            // label: {
            //   normal: {
            //     position: 'inner',
            //     show: true,
            //   },
            // },
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)',
            //   },
            // },
            label: {
              show: true,
              formatter: '{b}{c}',
              position: 'outside',
              padding: [0, -40],
              color: '#fff',
            },
            labelLayout: {
              hideOverlap: false,
              verticalAlign: 'bottom',
              dy: -2,
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: '30',
            //     fontWeight: 'bold',
            //   },
            // },
            labelLine: {
              show: true,
              showAbove: true,
              length: 20,
              length2: 36,
            },
          },
        ],
      }
      myChart.setOption(this.bottomOption)
    },
  },
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.ml-8 {
  margin-left: 8px;
}
.echarts {
  margin-top: -32px;
}
</style>
